import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";

@Component({
  selector: "gen-kpi-circle",
  templateUrl: "./gen-kpi-circle.component.html",
  styleUrls: ["./gen-kpi-circle.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class GenKpiCircleComponent implements OnInit {
  @Input() cnt: number;
  @Input() label: string;
  @Input() pct: number;
  @Input() deltaCnt: number;
  @Input() arrowType: string;
  @Input() deltaColor: string;
  @Input() circleColor: string;
  @Input() large: boolean = false;
  @Input() small: boolean = false;
  @Input() labelColor: string;

  constructor() {}

  ngOnInit(): void {}
}
